var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#ffffff;}\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,0C4.5,0,0,4.5,0,10c0,5.5,4.5,10,10,10s10-4.5,10-10C20,4.5,15.5,0,10,0z M5.2,12.1c0.9,0.4,2.1,0,2.5-0.9 h0h1.5C9,12.4,8,13.4,6.8,13.7c-1.8,0.4-3.6-0.7-4-2.4c-0.4-1.8,0.7-3.6,2.4-4c1.8-0.4,3.6,0.7,4,2.4H7.8c-0.2-0.4-0.5-0.8-0.9-1 c-0.9-0.4-2.1,0-2.5,0.9C3.9,10.6,4.3,11.7,5.2,12.1z M16.7,12.3c-1.1,1.5-3.1,1.9-4.6,0.8v0.3h-1.4V4H12v3.7 c0.5-0.3,1-0.5,1.6-0.6h0.2v0c0.7,0,1.4,0.2,2,0.6C17.4,8.8,17.7,10.8,16.7,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.9,8.6c-0.1,0-0.1,0-0.2,0c-0.7,0.1-1.2,0.5-1.5,1.1c-0.2,0.5-0.2,1.1,0,1.6c0,0.1,0.1,0.2,0.1,0.2 c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.1,0.3,0.2,0.4,0.3h0c0.2,0.1,0.3,0.1,0.5,0.1h0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2,0h0l0.2,0 c0.6-0.1,1.1-0.5,1.3-1v0c0-0.1,0.1-0.2,0.1-0.2c0-0.1,0-0.2,0.1-0.2v-0.1v0c0-0.1,0-0.2,0-0.3C15.8,9.4,14.9,8.6,13.9,8.6z"
  }))));
}

export default SvgCb;